import {
    login as loginRequest,
    logout as logoutRequest,
    checkUser,
    saveUserProfiles
} from '../api/auth';

import { useAuthStore } from '../stores/useAuthStore';
import { useLoadingStore } from '../stores/useLoadingStore';
import { useDateStore } from '../stores/useDateStore';
import { useLinesStore } from '../stores/useLinesStore';
import { useClientsStore } from '../stores/useClientsStore';
import { useVehiclesStore } from '../stores/useVehiclesStore';
import { useDriversStore } from '../stores/useDriversStore';
import { useTripsStore } from '../stores/useTripsStore';
import { useMapStore } from '../stores/map/useMapStore';
import { useHourFilterStore } from '../stores/useHourFilterStore';
import { usePontosItinerarioStore } from '../stores/usePontosItinerarioStore';
import { usePontosOperacionaisStore } from '../stores/usePontosOperacionaisStore';
import { useOperationalMapStore } from '../stores/useOperationalMapStore';
import { useTripsVehicleConflictsStore } from '../stores/useTripsVehicleConflictsStore';
import { closeFiltersWindow } from '../utils/filtersWindow';

const {
  startLoading,
  stopLoading,
  setLoadingTxt
} = useLoadingStore.getState();

export async function carregarUsuario() {

    const {
        setUser,
        setPerfisDisponiveis,
        setPerfisSelecionados
    } = useAuthStore.getState();

    try {

         const {
            status,
            error,
            data
        } = await checkUser();

        if (status !== 200) {
            setUser(null);
            return {
                status,
                error
            };
        }

        const user = data?.user || null;

        const tripsState = useTripsStore.getState();

        const currentUserId =
            user?.id != null
                ? String(user.id)
                : null;

        if (
            tripsState.tripsCacheUserId !== null &&
            tripsState.tripsCacheUserId !== currentUserId
        ) {
            tripsState.resetTrips();
        }

        tripsState.setTripsCacheUserId(currentUserId);

        setUser(user);

        setPerfisDisponiveis(data?.perfisDisponiveis || []);

        setPerfisSelecionados(data?.perfisSelecionados || []);

        return {
            status,
            error
        };
        
    } catch {
        setUser(null);
        return {
            status: 401,
            error: 'Erro ao logar.'
        };
    }
}

export async function login(email, password) {

    startLoading('Entrando...', false);

    const { setUser } = useAuthStore.getState();

    try {

        const {
            status,
            error
        } = await loginRequest({
            email,
            password
        });


        if (status !== 200) {
            return {
                status,
                error
            };
        }

        setLoadingTxt('Validando usuário...', false);

        const result = await carregarUsuario();
        return result;
        
    } catch  {
        setUser(null);
        return {
            status: 401,
            error: 'Erro ao validar usuário'
        };
    } finally {
        stopLoading(false);
    }
}

export async function logout() {

    startLoading('Saindo...', false);

    try {

        await logoutRequest();
        closeFiltersWindow();

    } finally {

        useAuthStore.getState().reset();
        useDateStore.getState().resetSelectedDate();
        useLinesStore.getState().resetLines();
        useClientsStore.getState().resetClientes();
        useVehiclesStore.getState().resetVehicles();
        useDriversStore.getState().resetDrivers();
        useMapStore.getState().resetMap();
        useHourFilterStore.getState().reset();
        usePontosItinerarioStore.getState().resetPontos();
        usePontosOperacionaisStore.getState().resetPontosOperacionais();
        useOperationalMapStore.getState().reset();
        useTripsStore.getState().resetTrips();
        useTripsVehicleConflictsStore.getState().clearConflicts();

        const {
            setLoadingClients,
            setLoadingVehicles,
            setLoadingDrivers,
            setLoadingLines,
            setLoadingTrips
        } = useLoadingStore.getState();
        
        setLoadingClients(true);
        setLoadingVehicles(true);
        setLoadingDrivers(true);
        setLoadingLines(true);
        setLoadingTrips(true);
        stopLoading();

    }

}

export async function updateProfiles() {

    const { perfisSelecionados } = useAuthStore.getState();

    try {

        await saveUserProfiles(perfisSelecionados);
        
    } catch (error) {
        console.error(
            'Erro ao salvar perfis',
            error
        );
    }

}